var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\n   >\n   ", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M 26 2 C 13.259016 2 3 12.360055 3 25 C 3 37.645455 13.354545 48 26 48 C 35.900347 48 41.951796 43.426386 45.099609 37.773438 C 48.247423 32.120489 48.63188 25.497876 47.677734 20.992188 L 47.511719 20.203125 L 25 20.095703 L 25 21.099609 L 25 30.5 L 36.431641 30.5 C 34.686862 34.491527 31.232881 37.199219 26 37.199219 C 19.238813 37.199219 13.699219 31.75985 13.699219 24.900391 C 13.699219 18.040931 19.22968 12.699219 26 12.699219 C 29.057576 12.699219 31.818811 13.806864 33.943359 15.654297 L 34.648438 16.265625 L 42.253906 8.6601562 L 41.46875 7.9550781 C 37.394931 4.2990866 31.95731 2 26 2 z M 26 4 C 31.058339 4 35.659339 5.8640551 39.28125 8.8046875 L 34.433594 13.652344 C 32.068847 11.863757 29.197935 10.699219 26 10.699219 C 18.17032 10.699219 11.699219 16.95985 11.699219 24.900391 C 11.699219 32.840931 18.161187 39.199219 26 39.199219 C 32.587097 39.199219 37.245694 35.247491 38.955078 29.798828 L 39.361328 28.5 L 27 28.5 L 27 22.103516 L 45.8125 22.195312 C 46.471442 26.196376 46.036865 31.978427 43.351562 36.800781 C 40.499376 41.922829 35.299653 46 26 46 C 14.445455 46 5 36.554545 5 25 C 5 13.439945 14.340984 4 26 4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5de4fb23a39558f48a7189b3585dedcf.svg";
export { ForwardRef as ReactComponent };